/** @file Stage-level Pointer Events routing → tool FSM. */
import { appStore } from "../core/state.js";
import { pxToMeters } from "../core/coords.js";
import { onPointerDown, onPointerMove, onPointerUp, cancelDraft } from "./tool-fsm.js";
import { tokenIdAt } from "../render/tokens.js";
import { drawingIdAt } from "../render/drawings.js";

/** @type {import("konva").default.Stage | null} */
let boundStage = null;

/**
 * @param {import("konva").default.Stage} stage
 */
export function attachPointerEvents(stage) {
  boundStage = stage;

  stage.on("pointerdown", () => {
    const t = appStore.get().transform;
    if (!t) {
      return;
    }
    const pos = stage.getPointerPosition();
    if (!pos) {
      return;
    }
    const meters = pxToMeters(t, { px: pos.x, py: pos.y });
    const tokenId = tokenIdAt(stage, { px: pos.x, py: pos.y });
    const drawingId = drawingIdAt(stage, { px: pos.x, py: pos.y });
    /** @type {{ isToken: boolean, isDrawing: boolean, drawingId?: string }} */
    const hit = {
      isToken: Boolean(tokenId),
      isDrawing: Boolean(drawingId),
    };
    if (drawingId) {
      hit.drawingId = drawingId;
    }
    onPointerDown(meters, hit);
  });

  stage.on("pointermove", () => {
    const t = appStore.get().transform;
    if (!t) {
      return;
    }
    const pos = stage.getPointerPosition();
    if (!pos) {
      return;
    }
    onPointerMove(pxToMeters(t, { px: pos.x, py: pos.y }));
  });

  stage.on("pointerup", () => onPointerUp());
  stage.on("pointercancel", () => cancelDraft());
}

/** Test helper. */
export function __detachPointerEvents() {
  boundStage?.off("pointerdown pointermove pointerup pointercancel");
  boundStage = null;
}
